import List from '.';
import { Space, Switch, Tooltip } from 'antd';
import { cutLongText, formatCurrency, formatCurrencyToExport } from '../../../services/utils';
import moment from 'moment';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { ColumnProps } from "antd/es/table";

export default function ControlOperatorsPage() {
    const [changeWasPaid, setChangeWasPaid] = useState<{ value: boolean, id: number } | undefined>(undefined);

    const calculateValue = (record: any) => record?.value || 0;

    const columns: ColumnProps[] = [
        { title: 'Operador', dataIndex: ['operator', 'data', 'name'], key: 'operator' },
        { title: 'Referência', dataIndex: 'reference', key: 'reference' },
        { title: 'ID Reserva', dataIndex: 'id', key: 'id', sorter: false, width: 100 },
        { title: 'Data Reserva', dataIndex: 'start_date', key: 'start_date', sorter: true, width: 135,
            render: (_: any, record: any) => {
                return moment(record?.start_date, 'YYYY-MM-DD').format('DD/MM/YYYY');               
            }
        },
        {
            title: 'Data (1º serviço)', dataIndex: 'start', key: 'start', sorter: true, defaultSortOrder: 'descend', width: 170,
            render: (_: any, record: any) => {
                if (record?.serviceVouchers[0]?.voucher?.start) {
                    return moment(record?.serviceVouchers[0]?.voucher?.start, 'YYYY-MM-DD').format('DD/MM/YYYY');
                }

                return '';
            }
        },
        {
            title: 'Drop-off (1º serviço)', dataIndex: 'dropoff_location', key: 'dropoff_location', sorter: true, width: 200,
            render: (_: any, record: any) => {
                if (record?.serviceVouchers[0]?.voucher?.dropoff_location) {
                    return cutLongText(record?.serviceVouchers[0]?.voucher?.dropoff_location, 20);
                }

                return '';
            },
        },
        {
            title: 'Cliente', dataIndex: 'client_name', key: 'client', sorter: true,
            render: (_: any, record: any) => cutLongText(record?.client_name, 40)
        },
        {
            title: 'Valor reserva', dataIndex: 'value', key: 'value', width: 150, sorter: true,
            render: (_: any, record: any) => formatCurrency(record?.value || 0)
        },
        {
            title: 'Pagamento', dataIndex: 'was_paid', key: 'was_paid', sorter: true, width: 170,
            render: (_: any, record: any) => {
                return (<Tooltip title={record.was_paid ? 'Cancelar confirmação' : 'Confirmar pagamento'}>
                    <Space direction={isMobile ? 'vertical' : 'horizontal'}>
                        <Switch checked={record.was_paid}
                            style={{ marginRight: 10 }}
                            onChange={(event: boolean) => {
                                setChangeWasPaid({ value: event, id: record.id });

                                record.was_paid = event;
                            }} />
                        {record.was_paid ? 'Pago' : 'Não Pago'}
                    </Space>
                </Tooltip>);
            }
        }
    ];

    const label = 'Operador';
    const workerFilter = 'filter_operator_id';

    const onMapDataToExport = (data: any) => {
        let total = 0;

        const dados = data.map((record: any) => {
            total += (record?.data?.value || 0);

            return {
                'Operador': record?.relationships?.operator?.data?.name,
                'Referência': record?.data?.reference,
                'ID Reserva': record?.data?.id,
                'Data (1º serviço)': record?.relationships?.serviceVouchers[0]?.voucher?.start ? moment(record?.relationships?.serviceVouchers[0]?.voucher?.start, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
                'Drop-off (1º serviço)': record?.relationships?.serviceVouchers[0]?.voucher?.dropoff_location ? record?.relationships?.serviceVouchers[0]?.voucher?.dropoff_location : '',
                'Cliente': record?.data?.client_name,
                'Pagamento': record?.data?.was_paid ? 'Pago' : 'Não Pago',
                'Valor Reserva': formatCurrencyToExport(record?.data?.value || 0),
            };
        });

        return dados.concat([{
            'Operador': '',
            'Referência': '',
            'ID Reserva': '',
            'Data (1º serviço)': '',
            'Drop-off (1º serviço)': '',
            'Cliente': '',
            'Pagamento': 'TOTAL',
            'Valor Reserva': formatCurrencyToExport(total || 0)
        }]);
    };

    return (
        <div className="content_page">
            <List
                type="operators"
                label={label}
                workerFilter={workerFilter}
                columns={columns}
                onMapDataToExport={onMapDataToExport}
                changeWasPaid={changeWasPaid}
                calculateValue={calculateValue} />
        </div>
    )
}
